const CloseWonModal = ({ isOpen, onClose, onSave, formData, setFormData }) => {
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
      <div className="bg-white p-6 rounded shadow-lg w-96">
        <h2 className="text-lg font-bold mb-4">Move to Close Won</h2>
        <form onSubmit={handleSubmit}>
          <input
            name="final_Amount"
            type="text"
            placeholder="Final Amount"
            onChange={handleChange}
            required
            className="w-full border p-2 mb-2"
          />
          <input
            name="final_Profile_Color"
            type="text"
            placeholder="Final Profile Color"
            onChange={handleChange}
            required
            className="w-full border p-2 mb-2"
          />
          <input
            name="glass_Color_Type"
            type="text"
            placeholder="Glass Color Type"
            onChange={handleChange}
            required
            className="w-full border p-2 mb-2"
          />
          <input
            name="work_Complete_Date"
            type="date"
            onChange={handleChange}
            required
            onFocus={(e) => e.target.showPicker()}
            className="w-full border p-2 mb-2"
          />

          <div className="flex justify-end mt-4">
            <button
              type="button"
              className="bg-gray-500 text-white px-4 py-2 rounded mr-2"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-primary text-white px-4 py-2 rounded"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CloseWonModal;
